var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"left"}),_c('h1',{staticClass:"title",attrs:{"tabindex":"0"}},[_vm._v(_vm._s(_vm.$t('chat.title')))])])}
var staticRenderFns = []

export { render, staticRenderFns }